import { LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'

import { CashInstrumentAdminWithState } from './pages/cash-inst-with-state'
import { PageType } from './state/edit-cash-instruments-slice'

interface Props {
  pageType: PageType
}
export const CashInstrumentAdmin = ({ pageType }: Props) => (
  <LeftSideBar
    leftElement={<Navigation />}
    mainElement={<CashInstrumentAdminWithState pageType={pageType} />}
    topBarElement={<UserMenuTopBar />}
  />
)
